import { useEffect } from "react";

export default (onDismountFunc) => {
  useEffect(() => {
    return () => onDismountFunc();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}